import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

class ScheduleGradeAircraftLine extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      double: this.props.double,
      double_bool: this.props.double_bool,
      sgas_id: this.props.sgas_id,
    };

  }
  // Handlers
  handleCheckboxChange(name, event) {
    const target = event.target;
    const value = target.checked;
    this.setState({[name]: value});
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.sgas_id,
      double: value,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/aeronave/linha/dobra', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.double_bool !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        double_bool: newProps.double_bool,
        double: newProps.double,
        sgas_id: newProps.sgas_id,
        loaded: 1,
      });
    }
  }

  render() {
    var self = this;
    return (
    <td className="text-center table-schedule-main-double">
    <RequestApi ref={'request_api'} handleLoaded={this.props.handleLoaded} />
      <input
        name="double"
        type="checkbox"
        checked={this.state.double_bool}
        onChange={this.handleCheckboxChange.bind(this, 'double_bool')} />
    </td>
    );
  }
}

export default ScheduleGradeAircraftLine;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeAircraftLineDouble.js